<template>
    <div class="col-span-6 sm:col-span-4">
        <ValidationProvider
            :rules="rules"
            v-slot="v"
        >
            <fieldset>
                <legend class="text-base leading-6 text-gray-900">
                    {{ title }}
                    <span class="text-xs text-red-500" v-if="rules && rules.includes('required')">*</span>
                    <span
                        class="ml-2 text-xs text-red-500"
                        v-if="v.errors[0]"
                    >{{ v.errors[0] }}</span>
                </legend>

                <div class="mt-4">
                    <div
                        class="mt-1 flex items-center"
                        v-for="(val, key) in options"
                        :key="val"
                    >
                        <input
                            type="radio"
                            :id="key"
                            :class="v.errors[0] ? 'bg-pink-50' : ''"
                            class="form-radio h-4 w-4 text-indigo-600"
                            :checked="val == value"
                            :value="value"
                            @change="$emit('input', val)"
                        />
                        <label :for="key" class="ml-3">
                            <span
                                class="block text-sm leading-5 font-medium text-gray-700"
                            >{{ key }}</span>
                        </label>
                    </div>
                </div>
            </fieldset>
        </ValidationProvider>
    </div>
</template>

<script>
export default {
    name: 'radio-button-list',
    props: {
        title: String,
        options: Object,
        value: Number,
        rules: String,
    },

    data: function() {
        return {}
    },

    computed: {},

    methods: {
    },
}
</script>

<style scoped>
[data-tooltip]:hover {
    position: relative;
}
[data-tooltip]:hover::before {
    all: initial;
    font-family: Arial, Helvetica, sans-serif;
    display: inline-block;
    border-radius: 5px;
    padding: 10px;
    background-color: #777;
    content: attr(data-tooltip);
    color: #f9f9f9;
    position: absolute;
    bottom: 100%;
    width: 300px;
    left: 50%;
    transform: translate(-50%, 0);
    margin-bottom: 15px;
    text-align: center;
    font-size: 14px;
}
</style>